"use client";

import { createContext, useContext } from "react";

export type ReportReadingMode = "interactive" | "continuous";
const ReadingMode = createContext<ReportReadingMode>("interactive");
export const ReportReadingProvider = ReadingMode.Provider;
export const useReportReadingMode = () => useContext(ReadingMode);
